{
    "builderForm": {
        "submit": "Añadir aplicación"
    },
    "sidebarComponentBuilder": {
        "settings": "Configuración",
        "createPage": "Nueva página"
    },
    "builderSettingsModal": {
        "title": "Aplicación"
    },
    "builderSettingTypes": {
        "integrationsName": "Integraciones",
        "themeName": "Tema",
        "domainsName": "Dominios",
        "userSourcesName": "Usuarios",
        "generalName": "General"
    },
    "createPageModal": {
        "header": "Crear página",
        "submit": "Añadir página"
    },
    "pageForm": {
        "nameLabel": "Nombre",
        "errorNameNotUnique": "Ya existe una página con este nombre",
        "defaultName": "Página",
        "nameTitle": "Nombre",
        "pathSubtitle": "Se puede añadir un parámetro mediante :parámetro",
        "pathParamsTitle": "Parámetros de ruta",
        "nameSubtitle": "Nombre único de la página",
        "pathParamsSubtitle": "Están definidos por el :parámetro en la ruta",
        "pathParamsSubtitleTutorial": "Los parámetros de ruta se pueden utilizar para cargar datos dinámicamente, en función del parámetro proporcionado. Añada el :parámetro a la ruta para añadir uno.",
        "pathTitle": "Ruta",
        "namePlaceholder": "Introduzca un nombre...",
        "pathPlaceholder": "Introduzca una ruta...",
        "addAnotherParameter": "Agregar otro parámetro de cadena de consulta",
        "addParameter": "Agregar parámetro de cadena de consulta",
        "queryParamsSubtitleTutorial": "Los parámetros de consulta pueden usarse para cargar datos dinámicamente, según el parámetro proporcionado.",
        "queryParamsTitle": "Parámetros de cadena de consulta"
    },
    "headingElementForm": {
        "textError": "El valor es inválido.",
        "textPlaceholder": "Introducir texto...",
        "levelTitle": "Nivel",
        "textTitle": "Texto",
        "headingName": "Título {nivel} <h{nivel}>"
    },
    "tableElementForm": {
        "addField": "añadir campo",
        "itemsPerPage": "Artículos por página",
        "fieldType": "Tipo",
        "fieldValueLabel": "Valor",
        "fieldDefaultName": "Columna",
        "dataSource": "Fuente de datos",
        "fieldValuePlaceholder": "Introducir valor...",
        "itemsPerPagePlaceholder": "Introducir valor...",
        "fields": "Campos",
        "buttonColor": "Color de los botones",
        "selectSourceFirst": "Elige un origen para los datos y/o propiedad para comenzar a configurar tus campos.",
        "refreshFieldsFromDataSource": "Actualizar los campos de la fuente de datos",
        "name": "Nombre",
        "orientation": "Orientación",
        "orientationHorizontal": "Horizontal",
        "orientationVertical": "Vertical",
        "buttonLoadMoreLabel": "Mostrar más etiqueta",
        "propertySelectorMissingArrays": "No se encontró que se utilizaran campos de múltiples valores como datos.",
        "noName": "Nombre no especificado"
    },
    "linkElementForm": {
        "paramPlaceholder": "Introduce un valor...",
        "targetSelf": "Misma pestaña",
        "variantButton": "Botón",
        "paramsInErrorButton": "Actualizar parámetros",
        "targetNewTab": "Nueva pestaña",
        "variantLink": "Enlace",
        "url": "URL de destino",
        "navigateToNotSet": "Sin destino",
        "navigateToCustom": "URL personalizada",
        "urlPlaceholder": "Introducir una URL...",
        "pageParameterTypeError": "Tipo inválido",
        "text": "Texto",
        "variant": "Variante",
        "textPlaceholder": "Introducir texto...",
        "navigateTo": "Navegar a",
        "target": "Abrir en...",
        "paramsInErrorDescription": "Los parámetros guardados no coinciden con los parámetros de la página. Es probable que la página se haya eliminado o actualizado.",
        "buttonColor": "Color del botón"
    },
    "textElement": {
        "noValue": "Párrafo vacío...",
        "missingValue": "Falta texto...",
        "emptyValue": "Texto vacío..."
    },
    "linkFieldForm": {
        "fieldLinkNamePlaceholder": "Introducir valor...",
        "fieldValuePlaceholder": "Introducir valor...",
        "fieldLinkNameLabel": "Texto del enlace",
        "fieldValueLabel": "URL",
        "buttonColor": "Color de los botones"
    },
    "imageElementForm": {
        "uploadFileButton": "Subir archivo",
        "fileSourceTypeURL": "URL",
        "altTextTitle": "Texto alternativo",
        "urlWarning": "Nota: asegúrate de que controlas o confías en la URL introducida.",
        "fileLabel": "Imagen",
        "invalidUrlError": "URL inválida",
        "fileSourceTypeUpload": "Subir",
        "altTextDescription": "Es utilizado por los lectores de pantalla y se muestra si la imagen no se puede cargar",
        "maxWidthLabel": "Anchura máxima",
        "maxHeightLabel": "Altura máxima",
        "maxHeightPlaceholder": "Introduce una altura máxima en píxeles.",
        "maxWidthPlaceholder": "Introduce una anchura máxima en porcentaje.",
        "imageConstraintCover": "Portada",
        "imageConstraintCoverDisabled": "No disponible con altura máxima vacía.",
        "imageConstraintContain": "Contener",
        "imageConstraintContainDisabled": "No disponible con altura máxima.",
        "imageConstraintsLabel": "Restricciones",
        "imageConstraintFullWidth": "Extender a la anchura máxima"
    },
    "dataSourceForm": {
        "servicePlaceholder": "Selecciona un servicio",
        "namePlaceholder": "Nombre de la fuente",
        "errorUniqueName": "El nombre de la fuente de datos debe ser único.",
        "integrationPlaceholder": "Selecciona una integración",
        "nameLabel": "Nombre",
        "actionLabel": "Acción",
        "integrationLabel": "Integración"
    },
    "elementType": {
        "table": "Tabla",
        "formContainer": "Formulario",
        "textDescription": "Texto multilínea",
        "heading": "Título",
        "inputText": "Entrada de datos",
        "inputTextDescription": "Campo de entrada de datos",
        "text": "Párrafo",
        "headingDescription": "Título de la página",
        "image": "Imagen",
        "tableDescription": "Un elemento de la tabla",
        "columnDescription": "Contenedor de columnas",
        "button": "Botón",
        "link": "Enlace",
        "column": "Columnas",
        "imageDescription": "Mostrar imagen",
        "buttonDescription": "Un elemento de botón",
        "formContainerDescription": "Un elemento de formulario",
        "linkDescription": "Un enlace a la página/URL",
        "dropdown": "Desplegable",
        "dropdownDescription": "Elemento desplegable",
        "checkbox": "Casilla de verificación",
        "checkboxDescription": "Elemento casilla de verificación",
        "iframe": "iframe",
        "iframeDescription": "Marco en línea",
        "authForm": "Formulario de acceso",
        "authFormDescription": "Un formulario de acceso de usuario",
        "repeat": "Repetir",
        "repeatDescription": "Un conjunto repetible de elementos",
        "choice": "Selección",
        "choiceDescription": "Para la selección de uno o varios valores",
        "recordSelector": "Selector de registro",
        "recordSelectorDescription": "Un selector de registros relacionados",
        "dateTimePicker": "Selector de fecha y hora",
        "dateTimePickerDescription": "Un campo de entrada de fecha y hora",
        "headerDescription": "Contenedor compartido en varias páginas",
        "footer": "Pie de página de varias páginas",
        "footerDescription": "Un contenedor compartido entre páginas",
        "notAllowedUnlessBottom": "Este elemento solo está permitido en la parte inferior de la página",
        "notAllowedUnlessHeader": "Este elemento solo está permitido dentro del encabezado de la página",
        "notAllowedUnlessFooter": "Este elemento solo está permitido dentro del pie de página",
        "notAllowedInsideContainer": "Este elemento no está permitido dentro de un contenedor",
        "notAllowedInsideSameType": "Este elemento no está permitido en un contenedor del mismo tipo",
        "notAllowedLocation": "Este elemento no está permitido en esta ubicación",
        "header": "Encabezado de varias páginas",
        "notAllowedUnlessTop": "Este elemento solo está permitido en la parte superior de la página",
        "ratingInput": "Campo de puntuación",
        "ratingInputDescription": "Un elemento de campo de puntuación",
        "rating": "Puntuación",
        "ratingDescription": "Un elemento de puntuación",
        "invalidElementValue": "Elemento con valor inválido: {value}",
        "menu": "Menú",
        "menuDescription": "Elemento de menú",
        "simpleContainer": "Contenedor",
        "simpleContainerDescription": "Un contenedor para otros elementos",
        "fileInput": "Selección de archivo",
        "fileInputDescription": "Una entrada para subir archivos",
        "errorValueMissing": "Propiedad de valor faltante",
        "errorEmptyContainer": "Este contenedor está vacío",
        "errorParentWithDataSourceMissing": "No se ha seleccionado ninguna fuente de datos en el elemento ni en un contenedor padre",
        "errorDataSourceMissing": "No se ha seleccionado ninguna fuente de datos",
        "errorSchemaPropertyMissing": "No se ha seleccionado ninguna propiedad de esquema",
        "errorWorkflowActionInError": "Al menos una acción está mal configurada",
        "errorCollectionFieldInError": "Al menos un campo está mal configurado",
        "errorNavigateToPageMissing": "Falta la propiedad «Navegar a»",
        "errorPageParameterInError": "Al menos un parámetro de página está mal configurado",
        "errorNavigationUrlMissing": "Falta la propiedad «URL de navegación»",
        "errorImageFileMissing": "No se encontró el archivo de imagen",
        "errorImageUrlMissing": "Falta la propiedad «URL de imagen»",
        "errorNoWorkflowAction": "Falta configurar una acción del flujo de trabajo",
        "errorOptionsMissing": "No se ha configurado ninguna opción",
        "errorIframeUrlMissing": "Falta la propiedad «URL del iFrame»",
        "errorIframeContentMissing": "Falta el contenido de «iFrame»",
        "errorNoMenuItem": "No se ha configurado ningún elemento de menú",
        "errorMenuItemInError": "Al menos un menú está mal configurado",
        "errorSubMenuItemInError": "Al menos un submenú está mal configurado"
    },
    "verticalAlignmentSelector": {
        "alignmentTop": "Arriba",
        "alignmentBottom": "Inferior",
        "alignmentCenter": "Medio",
        "alignment": "Alineación vertical"
    },
    "dnsStatus": {
        "hostHeader": "Anfitrión",
        "valueHeader": "Valor",
        "typeHeader": "Tipo",
        "description": "Visita la configuración DNS de tu dominio y realiza los siguientes cambios"
    },
    "horizontalAlignmentSelector": {
        "alignmentLeft": "Izquierda",
        "alignmentRight": "A la derecha",
        "alignment": "Alineación horizontal",
        "alignmentCenter": "Centro"
    },
    "duplicatePageJobType": {
        "duplicating": "Duplicando",
        "duplicatedTitle": "Página duplicada",
        "name": "Duplicar página"
    },
    "defaultStyleForm": {
        "widthLabel": "Anchura",
        "boxTop": "Arriba",
        "backgroundLabel": "Fondo",
        "backgroundColor": "Color de fondo",
        "boxBottom": "Abajo",
        "boxLeft": "Izquierda",
        "boxRight": "Derecha",
        "backgroundImage": "Imagen",
        "backgroundImageMode": "Modo de relleno",
        "cssClasses": "Clases de CSS",
        "cssClassesHelp": "Establece una lista de clases separadas por espacios para este elemento que aparecerá en el HTML generado.",
        "cssClassesPlaceholder": "Introduce las clases CSS…"
    },
    "updateUserSourceForm": {
        "nameFieldLabel": "Nombre",
        "nameFieldPlaceholder": "Introduce un nombre...",
        "integrationFieldLabel": "Integración",
        "authTitle": "Autenticación",
        "addProvider": "Añadir proveedor"
    },
    "elementForms": {
        "urlInputPlaceholder": "Introducir URL...",
        "textInputPlaceholder": "Introducir texto...",
        "invalidFormula": "La fórmula es inválida"
    },
    "mainThemeConfigBlock": {
        "colorsLabel": "Colores",
        "primaryColor": "Primario",
        "headingValue": "Título <h{i}>",
        "typography": "Tipografía",
        "headingLabel": "Título {i} (h{i})",
        "secondaryColor": "Secundario"
    },
    "domainSettings": {
        "noDomainMessage": "Aún no has asociado un dominio a esta aplicación. Debes añadir un dominio para poder publicar tu aplicación. Puedes publicar diferentes versiones de tu aplicación para cada dominio listado aquí.",
        "addDomain": "Añadir dominio",
        "titleOverview": "Dominios",
        "titleAddDomain": "Añadir dominio"
    },
    "elementMenu": {
        "moveRight": "Mover a la derecha",
        "moveDown": "Bajar",
        "moveUp": "Subir",
        "moveLeft": "Mover a la izquierda",
        "selectParent": "Seleccionar padre",
        "drag": "Arrastrar para reordenar"
    },
    "pageHeaderItemTypes": {
        "labelVariables": "Variables",
        "labelElements": "Elementos",
        "labelSettings": "Configuración de página",
        "labelDataSource": "Datos"
    },
    "inputTextElementForm": {
        "placeholderPlaceholder": "Introduce un marcador de posición (opcional)",
        "valueTitle": "Valor por defecto",
        "valuePlaceholder": "Introducir un valor por defecto (opcional)",
        "placeholderTitle": "Marcador de posición",
        "labelTitle": "Etiqueta",
        "requiredTitle": "Requerido",
        "labelPlaceholder": "Introducir una etiqueta (opcional)",
        "rowsTitle": "Número de líneas",
        "multilineTitle": "Multilínea",
        "rowsPlaceholder": "Introduce el número de filas de esta entrada",
        "validationTypeAnyLabel": "Cualquier",
        "validationTypeIntegerLabel": "Número",
        "validationTypeIntegerDescription": "Forzar un valor numérico en este campo (acepta enteros y decimales).",
        "validationTypeEmailLabel": "Correo electrónico",
        "validationTypeEmailDescription": "Implemente un valor de dirección de correo electrónico en esta entrada.",
        "validationTypeAnyDescription": "Permite establecer cualquier valor en esta entrada.",
        "inputType": "Tipo de entrada",
        "inputTypeTextLabel": "Texto",
        "inputTypePasswordLabel": "Contraseña",
        "passwordTypeWarning": "Las contraseñas son datos sensibles. Tenga cuidado con la forma en que maneja y almacena las contraseñas en su aplicación."
    },
    "widthSelector": {
        "widthFull": "Anchura completa",
        "widthAuto": "Auto",
        "width": "Anchura"
    },
    "domainCard": {
        "detailLabel": "Mostrar detalles",
        "refresh": "Actualizar configuración",
        "unpublishedDomainWarning": "Por favor, publica la aplicación para que esté disponible en este dominio."
    },
    "buttonElementForm": {
        "valuePlaceholder": "Introducir texto...",
        "valueLabel": "Texto del botón",
        "buttonColor": "Color de los botones"
    },
    "workflowActionTypes": {
        "updateRowLabel": "Actualizar fila",
        "createRowLabel": "Crear fila",
        "notificationLabel": "Mostrar notificación",
        "openPageLabel": "Abrir página",
        "logoutLabel": "Cerrar sesión",
        "refreshDataSourceLabel": "Refrescar fuente de datos",
        "deleteRowLabel": "Borrar fila",
        "httpRequest": "Enviar solicitud HTTP",
        "errorNavigateToPageMissing": "Falta la propiedad «Navegar a»",
        "errorPageParameterInError": "Al menos un parámetro de página está mal configurado",
        "errorNavigationUrlMissing": "Falta la propiedad «URL de navegación»",
        "errorDataSourceMissing": "No se ha seleccionado ninguna fuente de datos"
    },
    "widthTypes": {
        "full": "Anchura completa",
        "small": "Pequeño",
        "medium": "Medio",
        "normal": "Normal",
        "fullBleed": "Sangrado total",
        "fullWidth": "Anchura total"
    },
    "userSourceSettings": {
        "titleOverview": "Fuentes del usuario",
        "titleUpdateUserSource": "Editar fuente de usuario",
        "titleAddUserSource": "Nueva fuente de usuarios",
        "addUserSource": "Añadir fuente de usuario",
        "noUserSourceMessage": "Aún no has añadido un origen de usuario a esta aplicación. Debes añadir un origen de usuario si quieres que los usuarios puedan autenticar tu aplicación."
    },
    "publicPage": {
        "pageNotFound": "Página no encontrada",
        "siteNotFound": "Sitio no encontrado",
        "loginToastTitle": "Autenticación exitosa",
        "loginToastMessage": "Has iniciado sesión correctamente.",
        "authorizedToastTitle": "Autenticación requerida",
        "authorizedToastMessage": "Debes iniciar sesión para acceder a esta página. Por favor, inicia sesión para continuar."
    },
    "integrationSettings": {
        "integrationMessage": "Puedes crear nuevas integraciones añadiendo una fuente de datos, una acción o una autenticación de usuario.",
        "noIntegrationMessage": "Aún no has creado ninguna integración. Se pueden crear añadiendo una fuente de datos, una acción o una autenticación de usuario.",
        "title": "Integraciones"
    },
    "upsertRowWorkflowActionForm": {
        "rowIdPlaceholder": "Selecciona un ID de fila",
        "fieldMappingPlaceholder": "Elige un valor de campo",
        "integrationDropdownLabel": "Integración",
        "rowIdLabel": "ID de fila",
        "noTableSelectedMessage": "Elige una tabla para empezar a configurar tus campos."
    },
    "customDomainForm": {
        "domainNameLabel": "Nombre de dominio"
    },
    "subDomainDetails": {
        "text": "Los ajustes DNS del dominio ya han sido configurados y comprobados. Funciona sin realizar ningún cambio adicional."
    },
    "imageElement": {
        "emptyState": "No hay texto alternativo definido...",
        "missingValue": "Falta texto alternativo...",
        "emptyValue": "Texto alternativo vacío..."
    },
    "columnElementForm": {
        "columnGapPlaceholder": "Introducir espacio entre columnas...",
        "columnGapTitle": "Espacio entre columnas",
        "columnAmountTitle": "Disposición",
        "columnAmountName": "sin columnas | 1 columna | {columnaCantidad} columnas",
        "verticalAlignment": "Alineación vertical",
        "customWeightsHelper": "Utiliza 0 cuando una columna deba ajustarse únicamente al ancho de su contenido. Las demás columnas repartirán el espacio sobrante.",
        "errorCustomWeightsMinimum": "Los pesos de las columnas deben ser 0 o mayores",
        "columnStackingTitle": "Apila columnas por tipo de dispositivo",
        "customWeightsTitle": "Pesos personalizados de columnas",
        "columnStackingHorizontal": "Lado a lado",
        "customLayout": "Personalizado",
        "columnStackingStacked": "Apilado"
    },
    "pageSettings": {
        "pageUpdatedTitle": "Cambiado",
        "pageUpdatedDescription": "Se ha actualizado la configuración de la página.",
        "title": "Página"
    },
    "notificationWorkflowActionForm": {
        "descriptionLabel": "Descripción",
        "descriptionPlaceholder": "Introducir texto...",
        "titleLabel": "Título",
        "titlePlaceholder": "Introducir texto..."
    },
    "dataSourceContext": {
        "addDataSource": "Añadir nueva fuente de datos",
        "noDataSourceMessage": "Las fuentes de datos pueden utilizarse para obtener datos de fuentes internas o externas y mostrarlos en la página.",
        "noDataSourceTitle": "Aún no has añadido una fuente de datos.",
        "sharedDataSourceTitle": "Compartido entre páginas",
        "pageDataSourceTitle": "Para esta página",
        "sharedDataSourceDescription": "Accesible en todas las páginas y se obtiene una vez en la primera carga de la página.",
        "pageDataSourceDescription": "Se obtiene cuando el usuario navega a esta página."
    },
    "pageSettingsTypes": {
        "pageName": "Página"
    },
    "publishActionModal": {
        "publish": "Publicar",
        "publishSucceedDescription": "El sitio se ha publicado correctamente.",
        "publishSucceedTitle": "Sitio publicado",
        "description": "Publica tu aplicación en uno de los dominios. Ten en cuenta que tu aplicación puede tener varios dominios, cada uno con una versión diferente de la aplicación.",
        "title": "Publicar",
        "publishFailedTitle": "Error en la publicación del sitio",
        "openInNewTab": "Abrir en una pestaña nueva",
        "noDomain": "Necesitas tener al menos un dominio para poder publicar tu aplicación.",
        "publishFailedDescription": "La publicación del sitio ha fallado. Vuelva a intentarlo más tarde.",
        "importingState": "Importando",
        "publishSucceedLink": "Ver sitio",
        "addDomain": "Añadir dominio"
    },
    "currentRecordDataProviderType": {
        "index": "Índice",
        "firstPartName": "Fuente de datos: {nombre}",
        "schemaProperty": "{prefixName}: {schemaProperty}"
    },
    "pageSidePanelType": {
        "visibility": "Visibilidad",
        "general": "General",
        "events": "Eventos",
        "style": "Estilo",
        "eventsTabDeactivatedNoEvents": "Este elemento no admite eventos",
        "eventsTabInError": "Una o más acciones están mal configuradas."
    },
    "addElementModal": {
        "title": "Añadir nuevo elemento",
        "searchPlaceholder": "Buscar elementos",
        "disabledElementTooltip": "No disponible dentro de este elemento",
        "elementInProgress": "Añadiendo elemento..."
    },
    "domainTypes": {
        "subDomain": "Subdominio de {dominio}",
        "customName": "Dominio personalizado",
        "subDomainName": "Subdominio"
    },
    "domainForm": {
        "notUniqueDomain": "El dominio proporcionado ya está en uso",
        "invalidDomain": "El nombre de dominio proporcionado es inválido"
    },
    "dispatchWorkflowActionError": {
        "defaultMessage": "Se ha producido un error que ha provocado este evento.",
        "defaultTitle": "Error de evento",
        "formDataInvalidTitle": "Formulario inválido",
        "formDataInvalidMessage": "Uno o más campos contienen valores no válidos."
    },
    "dataProviderType": {
        "currentRecord": "Fuente de datos",
        "formData": "Datos del formulario",
        "pageParameter": "Parámetro",
        "dataSource": "Registros de datos",
        "user": "Usuario",
        "previousAction": "Acción previa",
        "dataSourceContext": "Opciones disponibles",
        "metadata": "Metadatos"
    },
    "openPageWorkflowActionForm": {
        "urlLabel": "URL",
        "urlPlaceholder": "Introducir texto..."
    },
    "collectionFieldType": {
        "text": "Texto",
        "link": "Enlace",
        "boolean": "Booleano",
        "tags": "Etiquetas",
        "image": "Imagen",
        "button": "Botón",
        "rating": "Valoración",
        "errorValueMissing": "Propiedad de valor faltante"
    },
    "elementsContext": {
        "searchPlaceholder": "Buscar elementos",
        "noElements": "No se han encontrado elementos",
        "noPageElements": "Sin elementos para esta página"
    },
    "textElementForm": {
        "textTitle": "Texto",
        "textError": "El valor es inválido.",
        "textPlaceholder": "Introducir texto...",
        "textFormatTypeLabel": "Formato",
        "textFormatTypePlain": "Texto plano",
        "textFormatTypeMarkdown": "Markdown"
    },
    "createUserSourceForm": {
        "userSourceName": "Nombre",
        "userSourceIntegration": "Integración",
        "userSourceType": "Tipo"
    },
    "event": {
        "addAction": "añadir acción"
    },
    "pageErrors": {
        "errorStartingSlash": "Una ruta debe empezar por '/'",
        "errorUniquePathParams": "Los parámetros de la ruta deben ser únicos.",
        "errorPathNotUnique": "Ya existe una ruta con este nombre",
        "errorValidPathCharacters": "La ruta contiene caracteres inválidos",
        "errorNameNotUnique": "Ya existe una página con este nombre",
        "errorUniqueValidQueryParams": "Los nombres de los parámetros de consulta deben ser únicos y válidos.",
        "errorNameNotUniqueDescription": "Por favor, introduce un nombre único para la página"
    },
    "addElementButton": {
        "label": "Elemento"
    },
    "buttonElement": {
        "noValue": "Sin nombre...",
        "missingValue": "Falta el texto del botón...",
        "emptyValue": "Texto del botón vacío..."
    },
    "formDataProviderType": {
        "nodeMissing": "Falta"
    },
    "lastPublishedDomainDate": {
        "lastPublished": "Última publicación:",
        "neverPublished": "nunca"
    },
    "textFieldForm": {
        "fieldValuePlaceholder": "Introducir valor...",
        "fieldValueLabel": "Valor"
    },
    "tableElement": {
        "empty": "No se ha encontrado ningún artículo.",
        "showMore": "Ver más"
    },
    "fontSidePanelForm": {
        "label": "Color de fuente"
    },
    "emptySidePanelState": {
        "message": "Haz clic en uno de los elementos para ver más detalles"
    },
    "styleBoxForm": {
        "borderLabel": "Tamaño",
        "paddingLabel": "Margen interno",
        "error": "El valor debe ser un número entero entre 0 y 200.",
        "borderColor": "Color del borde",
        "marginLabel": "Margen"
    },
    "backgroundTypes": {
        "color": "Color",
        "none": "Ninguno"
    },
    "linkElement": {
        "noValue": "Sin nombre...",
        "missingValue": "Falta el texto del enlace...",
        "emptyValue": "Texto del enlace vacío..."
    },
    "pagePreview": {
        "emptyMessage": "Haz clic para crear un elemento",
        "header": "ENCABEZAMIENTO",
        "footer": "PIE DE PÁGINA"
    },
    "eventTypes": {
        "submitLabel": "Al enviar",
        "clickLabel": "Al hacer clic",
        "afterLoginLabel": "Después de iniciar sesión"
    },
    "pageActionTypes": {
        "publish": "Publicar",
        "preview": "Previsualizar"
    },
    "headingElement": {
        "noValue": "Sin título...",
        "emptyValue": "Título vacío...",
        "missingValue": "Falta el título..."
    },
    "formContainerElementForm": {
        "submitButtonLabel": "Botón de envío",
        "submitButtonPlaceholder": "Introducir valor...",
        "buttonColor": "Color de los botones",
        "resetToInitialValuesTitle": "Restablecer los valores por defecto tras el envío",
        "resetToInitialValuesDescription": "Si está marcada, los valores por defecto del formulario se utilizarán para restablecer el formulario después de un envío exitoso. Si no está marcada, se mantendrán los valores del usuario."
    },
    "subDomainForm": {
        "domainNameLabel": "Nombre de dominio"
    },
    "linkField": {
        "details": "Detalles"
    },
    "getFormulaComponent": {
        "errorTooltip": "Referencia inválida"
    },
    "pathParamTypes": {
        "textName": "Texto",
        "numericName": "Numérico"
    },
    "dropdownOptionSelector": {
        "value": "Valor",
        "name": "Nombre",
        "addOption": "añadir opción",
        "label": "Opciones"
    },
    "checkboxElementForm": {
        "labelTitle": "Nombre de la opción",
        "valueTitle": "Valor por defecto",
        "requiredTitle": "Obligatorio"
    },
    "generalForm": {
        "placeholderPlaceholder": "Introduce un texto de ejemplo",
        "requiredTitle": "Obligatorio",
        "labelTitle": "Etiqueta",
        "labelPlaceholder": "Introduce la etiqueta",
        "valueTitle": "Valor",
        "valuePlaceholder": "Introduce un valor",
        "placeholderTitle": "Texto de ejemplo",
        "validationTitle": "Validación",
        "defaultValueTitle": "Valor predeterminado",
        "defaultValuePlaceholder": "Introduce el valor predeterminado"
    },
    "iframeElementForm": {
        "empty": "Iframe vacío...",
        "sourceTypeLabel": "Tipo de fuente",
        "urlLabel": "URL",
        "urlPlaceholder": "Enlace al recurso externo que se va a incrustar",
        "urlHelp": "Nota: asegúrate de que controlas o confías en la URL introducida.",
        "embedLabel": "Incrustar",
        "embedPlaceholder": "Contenido HTML en bruto para incrustar",
        "heightLabel": "Altura (en px)",
        "heightPlaceholder": "Altura en píxeles",
        "missingValue": "Falta la fuente IFrame...",
        "emptyValue": "Fuente IFrame vacía..."
    },
    "linkNavigationSelection": {
        "navigateTo": "Navegar a",
        "navigateToCustom": "URL personalizada",
        "paramPlaceholder": "Introduce un valor...",
        "paramsInErrorButton": "Actualizar parámetros",
        "url": "URL de destino",
        "urlPlaceholder": "Introduce una URL...",
        "paramsInErrorDescription": "Los parámetros guardados no coinciden con los parámetros de la página. Es probable que la página se haya eliminado o actualizado.",
        "target": "Abrir en...",
        "targetSelf": "Misma pestaña",
        "targetNewTab": "Nueva pestaña"
    },
    "dispatchDataSourceError": {
        "defaultTitle": "Error de carga de datos",
        "defaultMessage": "Se ha producido un error al cargar los datos de la página."
    },
    "authFormElementForm": {
        "userSource": "Fuente del usuario"
    },
    "authFormElement": {
        "email": "Correo electrónico",
        "password": "Contraseña",
        "emailPlaceholder": "Introduce tu correo electrónico...",
        "passwordPlaceholder": "Introduce tu contraseña...",
        "selectOrConfigureUserSourceFirst": "Elige un origen de usuario para empezar a utilizar este elemento de inicio de sesión."
    },
    "userSourceUsersContext": {
        "searchPlaceholder": "Buscar usuario",
        "unnamed": "Sin nombre",
        "anonymous": "Anónimo",
        "noEmail": "Sin correo electrónico"
    },
    "userSelector": {
        "viewAs": "Ver como: {usuario}",
        "anonymous": "Anónimo",
        "member": "{prefix} miembro"
    },
    "formContainerElement": {
        "submitDeactivatedText": "Rellena todos los campos obligatorios para enviar",
        "defaultSubmitButtonLabel": "Enviar"
    },
    "visibilityForm": {
        "allVisitors": "Todos los visitantes",
        "loggedInVisitors": "Visitantes registrados",
        "notLoggedInVisitors": "Visitantes no registrados",
        "warningTitle": "Esto es una característica de seguridad",
        "warningMessage": "Revisa la &lt;a href='https://grouper.io/user-docs/application-builder-element-visibility#note-accessing-hidden-data-via-api'&gt;documentación&lt;/a&gt; para aprender más sobre cómo aseguramos los datos.",
        "excludedRolesLabel": "todos los roles excepto",
        "switchAllowLabel": "Permitir",
        "switchDisallowLabel": "No permitir",
        "rolesSelectAll": "Seleccionar todo",
        "rolesDeselectAll": "Deseleccionar todo",
        "rolesSelectHint": "Selecciona uno o varios roles",
        "roleTypesHint": "Selecciona un tipo de función",
        "roleTypeAllowAllRoles": "Todos los roles",
        "roleTypeAllowAllRolesExcept": "No permitir roles...",
        "roleTypeDisallowAllRolesExcept": "Permitir roles...",
        "rolesAllMembersOf": "Todos los miembros de {name}",
        "noRole": "Sin función",
        "errorFetchingRolesTitle": "No se han podido recuperar los roles de usuario",
        "errorFetchingRolesMessage": "Se ha producido un problema al recuperar los roles de usuario.",
        "visibilityCondition": "Condición de visibilidad",
        "visibilityConditionHelper": "Si el resultado de esta fórmula es «verdadero», y la elección del visitante anterior es «verdadero», el elemento será visible. Esta condición solo afecta la visibilidad del elemento. Para excluir datos de la respuesta del servidor, usa la opción de filtrado por rol de usuario anterior.",
        "visibilityConditionPlaceholder": "Condición…",
        "documentationLink": "documentación"
    },
    "generalSettings": {
        "titleOverview": "General",
        "labelForm": "Icono de sitio (favicon)",
        "labelDescription": "Escoge un ICO, PNG, GIF o JPEG de 128x128px.",
        "cantUploadFaviconTitle": "No se puede cargar el archivo favicon",
        "cantUpdateApplicationTitle": "No se ha podido actualizar la aplicación",
        "cantUpdateApplicationDescription": "Lo sentimos, no se ha podido actualizar la aplicación.",
        "labelButton": "Subir favicon",
        "cantUploadFaviconDescription": "Lo sentimos, no se ha podido cargar la imagen del favicon. Asegúrese de que el archivo de imagen es único y tiene un formato de imagen compatible."
    },
    "repeatElement": {
        "empty": "No se ha encontrado ningún artículo.",
        "missingDataSourceTooltip": "Elige una fuente de datos para empezar a añadir elementos.",
        "showMore": "Ver más",
        "missingSchemaPropertyTooltip": "Elige una propiedad para comenzar a agregar elementos.",
        "emptyState": "No se han encontrado registros."
    },
    "repeatElementForm": {
        "dataSource": "Fuente de datos",
        "itemsPerPage": "Artículos por página",
        "itemsPerRowLabel": "Artículos por fila",
        "orientationLabel": "Orientación",
        "orientationHorizontal": "Horizontal",
        "itemsPerPagePlaceholder": "Introduce el valor...",
        "itemsPerRowDescription": "Número de columnas por fila y tipo de dispositivo.",
        "orientationVertical": "Vertical",
        "buttonLoadMoreLabel": "Mostrar más etiqueta",
        "toggleEditorRepetitionsLabel": "Desactivar temporalmente las repeticiones",
        "propertySelectorMissingArrays": "No se encontraron campos de valores múltiples para crear los patrones.",
        "gapLabel": "Espacio entre repeticiones",
        "gapVerticalLabel": "Vertical",
        "gapHorizontalLabel": "Horizontal"
    },
    "tagsFieldForm": {
        "fieldValuesLabel": "Valores",
        "fieldValuesPlaceholder": "Introducir valores...",
        "fieldColorsPlaceholder": "Introducir colores...",
        "fieldColorsLabel": "Colores"
    },
    "buttonFieldForm": {
        "labelPlaceholder": "Introduce una etiqueta...",
        "infoMessage": "Para configurar las acciones de este botón, abre la pestaña «Eventos» del elemento actual."
    },
    "imageInput": {
        "labelDescription": "Descripción por defecto",
        "labelButton": "Cargar"
    },
    "userDataProviderType": {
        "isAuthenticated": "Está autenticado",
        "id": "ID",
        "email": "Correo electrónico",
        "username": "Usuario",
        "role": "Rol"
    },
    "buttonField": {
        "noLabel": "Sin nombre..."
    },
    "themeConfigBlockType": {
        "color": "Colores",
        "button": "Botón",
        "link": "Enlace",
        "page": "Página",
        "typography": "Tipografía",
        "image": "Imagen",
        "input": "Entrada",
        "table": "Tabla"
    },
    "colorThemeConfigBlock": {
        "secondaryColor": "Secundario",
        "borderColor": "Borde",
        "successColor": "Éxito",
        "warningColor": "Aviso",
        "errorColor": "Error",
        "primaryColor": "Principal",
        "transparent": "Transparente",
        "customColors": "Colores personalizados",
        "addCustomColor": "Agregar color personalizado",
        "customColorPrefix": "Personalizado"
    },
    "pageThemeConfigBlock": {
        "backgroundColor": "Color de fondo",
        "backgroundImage": "Imagen de fondo",
        "backgroundMode": "Modo de fondo"
    },
    "colorThemeConfigBlockType": {
        "primary": "Principal",
        "secondary": "Secundario",
        "success": "Éxito",
        "warning": "Aviso",
        "error": "Error",
        "border": "Borde",
        "transparent": "Transparente"
    },
    "typographyThemeConfigBlock": {
        "headingLabel": "Encabezamiento {i} (h{i})",
        "headingValue": "Encabezamiento <h{i}>",
        "color": "Color",
        "size": "Tamaño",
        "textAlignment": "Alineación",
        "bodyLabel": "Cuerpo",
        "fontFamily": "Fuente tipográfica",
        "weight": "Peso",
        "decoration": "Decoración de texto"
    },
    "buttonThemeConfigBlock": {
        "backgroundColor": "Color de fondo",
        "button": "Botón",
        "defaultState": "Estado por defecto",
        "hoverState": "Estado de la imagen flotante",
        "textAlignment": "Alineación del texto",
        "alignment": "Alineación",
        "width": "Anchura",
        "padding": "Margen interno",
        "textColor": "Color del texto",
        "size": "Tamaño de letra",
        "borderRadius": "Radio del borde",
        "borderColor": "Color del borde",
        "borderSize": "Tamaño del borde",
        "fontFamily": "Fuente tipográfica",
        "activeState": "Estado activo",
        "weight": "Peso de fuente"
    },
    "linkThemeConfigBlock": {
        "defaultState": "Estado por defecto",
        "alignment": "Alineación",
        "fontFamily": "Fuente tipográfica",
        "link": "Enlace",
        "color": "Color",
        "hoverState": "Estado de la imagen flotante",
        "activeState": "Estado activo",
        "size": "Tamaño de fuente",
        "weight": "Peso de fuente",
        "decoration": "Decoración de texto"
    },
    "imageThemeConfigBlock": {
        "alignment": "Alineación",
        "maxWidthLabel": "Anchura máxima",
        "maxHeightLabel": "Altura máxima",
        "maxHeightPlaceholder": "Introduce una altura máxima",
        "maxWidthPlaceholder": "Introduce una anchura máxima",
        "imageConstraintsLabel": "Restricciones",
        "imageConstraintFullWidth": "Extender a la anchura máxima",
        "imageConstraintCover": "Portada",
        "imageConstraintContain": "Contener",
        "imageConstraintContainDisabled": "No disponible con altura máxima.",
        "imageConstraintCoverDisabled": "No disponible con altura máxima vacía.",
        "imageBorderRadiusLabel": "Radio de borde",
        "imageBorderRadiusPlaceholder": "Introduce el radio de borde de la imagen."
    },
    "choiceElementForm": {
        "multiple": "Permitir varios valores",
        "display": "Visualizar",
        "dropdown": "Desplegable",
        "checkbox": "Casilla de verificación",
        "radio": "Radio"
    },
    "choiceOptionSelector": {
        "value": "Valores de las opciones",
        "valuePlaceholder": "Introducir valor",
        "name": "Nombres de las opciones",
        "namePlaceholder": "Introducir nombre",
        "optionType": "Tipo de opciones",
        "manual": "Manual",
        "dataSource": "Fuente de datos",
        "formulas": "Fórmulas",
        "label": "Opciones",
        "addOption": "añadir opción",
        "addOptionDescription": "Haz clic en «añadir opción» para añadir opciones a tu desplegable"
    },
    "choiceElement": {
        "addOptions": "Añadir opciones para empezar a utilizar este elemento..."
    },
    "backgroundModes": {
        "tile": "Azulejo",
        "fit": "Encajar",
        "fill": "Llenar"
    },
    "customStyle": {
        "themeOverrides": "Anulación de temas",
        "configureThemeOverrides": "Configurar las modificaciones del tema para este elemento",
        "backToElement": "Volver a la configuración del elemento"
    },
    "resetButton": {
        "reset": "Restablecer el valor predeterminado del tema"
    },
    "inputThemeConfigBlock": {
        "textColor": "Color del texto",
        "borderColor": "Color del borde",
        "borderSize": "Tamaño del borde",
        "borderRadius": "Radio del borde",
        "padding": "Margen interno",
        "fontFamily": "Fuente tipográfica",
        "size": "Tamaño de letra",
        "label": "Etiqueta",
        "input": "Entrada",
        "backgroundColor": "Color de fondo",
        "weight": "Peso de fuente"
    },
    "tableThemeConfigBlock": {
        "borderColor": "Color del borde",
        "backgroundColor": "Color de fondo",
        "textColor": "Color del texto",
        "padding": "Margen interno",
        "fontFamily": "Fuente tipográfica",
        "size": "Tamaño",
        "fontSize": "Tamaño de letra",
        "table": "Tabla",
        "header": "Cabecera",
        "borderRadius": "Radio del borde",
        "separators": "Separadores",
        "verticalSeparatorColor": "Color vertical",
        "borderSize": "Tamaño del borde",
        "backgroundAlternateColor": "Color de las filas pares",
        "alignment": "Alineación",
        "cells": "Células",
        "verticalSeparatorSize": "Tamaño vertical",
        "horizontalSeparatorColor": "Color horizontal",
        "horizontalSeparatorSize": "Tamaño horizontal",
        "fontWeight": "Peso de fuente"
    },
    "abTable": {
        "empty": "No se ha encontrado ningún artículo.",
        "loading": "Cargando..."
    },
    "localGrouperServiceForm": {
        "integrationDropdownLabel": "Integración",
        "rowIdLabel": "ID de fila",
        "rowIdPlaceholder": "Seleccione un ID de fila"
    },
    "fieldMappingContext": {
        "enableField": "Habilitar campo",
        "disableField": "Desactivar campo"
    },
    "dropdown": {
        "empty": "No hay opciones disponibles"
    },
    "collectionElementForm": {
        "noSchemaPropertyMessage": "Elige una propiedad de origen de datos para usarla como el origen de los datos para tu elemento.",
        "noDataSourceMessage": "Elige una fuente de datos con varias filas para enumerar todos los resultados, o un origen para los datos de una sola fila para elegir una propiedad dentro de esta fila.",
        "propertyOptionLabel": "Acciones del usuario"
    },
    "imageFieldForm": {
        "fieldAltLabel": "Texto alternativo",
        "fieldAltPlaceholder": "Introducir valor...",
        "fieldSrcLabel": "Origen de la imagen",
        "fieldSrcPlaceholder": "Introducir valor",
        "fieldAltHelp": "Es utilizado por los lectores de pantalla y se muestra si la imagen no se puede cargar"
    },
    "serviceSchemaPropertySelector": {
        "label": "Propiedad",
        "noProperties": "No hay propiedades disponibles"
    },
    "dataSourceDropdown": {
        "label": "Origen de los datos",
        "noDataSources": "Sin origen para los datos disponibles",
        "shared": "compartido",
        "pageOnly": "esta página",
        "noSharedDataSources": "No hay fuentes de datos compartidas",
        "addNew": "Añadir nueva fuente de datos"
    },
    "recordSelectorElementForm": {
        "selectRecordsFrom": "Seleccionar registros de",
        "noDataSourceMessage": "Elija una fuente de datos con múltiples filas para listar todos los resultados.",
        "optionNameSuffix": "Sufijo del nombre de la opción",
        "optionNameSuffixPlaceholder": "Introduce un sufijo...",
        "optionNameSuffixHelper": "Este sufijo se añade a cada nombre de opción al abrir el desplegable y ayuda a distinguirlas.",
        "itemsPerPagePlaceholder": "Introduce el valor...",
        "multipleLabel": "Permitir varios valores",
        "record": "Registro {id}",
        "itemsPerPage": "Artículos por página"
    },
    "dataSourceCreateEditModal": {
        "editTitle": "Editar fuente de datos",
        "createTitle": "Crear fuente de datos",
        "sharedWarning": "Esta fuente de datos se comparte, por lo que los cambios pueden afectar a varias páginas."
    },
    "dataSourceItem": {
        "notConfigured": "No configurado"
    },
    "dataSourceItemContext": {
        "shareBetweenPages": "Compartir entre páginas",
        "unshareBetweenPages": "Descompartir de otras páginas"
    },
    "propertyOptionForm": {
        "sortHeading": "Ordenar",
        "searchHeading": "Búsqueda",
        "formDescription": "Elige qué propiedades dentro de la página de origen de datos de este elemento pueden filtrar, ordenar y buscar los visitantes.",
        "fieldHeading": "Campo",
        "filterHeading": "Filtro",
        "optionUnavailable": "No disponible",
        "noPropertiesAvailable": "No hay campos disponibles."
    },
    "recordSelectorElement": {
        "emptyState": "No se han encontrado registros.",
        "emptyAdhocState": "No se han encontrado registros que coincidan con '{query}'."
    },
    "common": {
        "dateFormatTitle": "Formato de la fecha",
        "dateFormatEU": "Europeo",
        "dateFormatISO": "ISO",
        "timeFormatTitle": "Formato de hora",
        "timeFormat24Hour": "24 horas",
        "timeFormat12Hour": "12 horas",
        "dateFormatUS": "Americano"
    },
    "dateTimePickerElementForm": {
        "includeTime": "Incluir fecha y hora",
        "invalidDateError": "Fecha no válida. Asegúrese de que la fecha ingresada coincida con el formato indicado."
    },
    "themeSettings": {
        "titleOverview": "Tema"
    },
    "pageVisibilitySettingsTypes": {
        "pageName": "Divulgación",
        "logInPageWarningTitle": "La página de inicio de sesión no está configurada",
        "logInPagewarningMessage": "Cuando un usuario anónimo intente acceder a esta página, será redirigido a una página de inicio de sesión. Establezca la página de inicio de sesión en la configuración general de la aplicación.",
        "logInPageInfoMessage": "Los usuarios anónimos que intenten acceder a esta página serán redirigidos a la página {logInPageName}.",
        "logInPageInfoTitle": "Los usuarios anónimos serán redirigidos"
    },
    "pageVisibilitySettings": {
        "allVisitors": "Todos los visitantes",
        "loggedInVisitors": "Visitantes registrados",
        "description": "Quién puede ver esta página",
        "title": "Visibilidad"
    },
    "builderLoginPageForm": {
        "pageDropdownLabel": "Página de inicio de sesión",
        "pageDropdownPlaceholder": "Seleccione una página",
        "pageDropdownDescription": "Seleccione la página de inicio de sesión a la que deben redirigirse los usuarios que no hayan iniciado sesión cuando intenten acceder a una página restringida."
    },
    "multiPageContainerElementForm": {
        "behaviour": "Comportamiento",
        "display": "Visualizar",
        "pagePosition": "Posición",
        "selectAll": "Seleccionar todo",
        "deselectAll": "Deseleccionar todo"
    },
    "pageShareType": {
        "all": "En todas las páginas",
        "only": "Solo en páginas seleccionadas",
        "except": "Excluir páginas seleccionadas"
    },
    "pageEditor": {
        "pageNotFound": "Página no encontrada",
        "title": "Constructor de aplicaciones"
    },
    "builderToast": {
        "details": "Detalles",
        "defaultTitle": "Error inesperado",
        "defaultMessage": "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.",
        "invalidContextTitle": "Solicitud inválida",
        "invalidContextMessage": "La solicitud es inválida.",
        "InvalidContentTitle": "Formulario inválido",
        "invalidContentMessage": "Uno o varios campos contienen valores inválidos.",
        "serviceMisconfiguredTitle": "Configuración incompleta",
        "serviceMisconfiguredMessage": "Por favor, revisa la configuración.",
        "errorWorkflowActionDispatch": "La acción \"{name}\" ha fallado: ",
        "errorDataSourceDispatch": "No se pudo cargar los datos de \"{name}\": "
    },
    "sidePanelGuidedTourStep": {
        "content": "**Pestaña General** – Configura el elemento seleccionado.\n\n**Pestaña Estilo** – Personaliza el margen interno, el margen externo, los bordes y más.\n\n**Pestaña Visibilidad** – Controla quién puede ver este elemento: usuarios conectados, usuarios desconectados o roles específicos.\n\n**Pestaña Eventos** – Si el elemento admite acciones, configúralas aquí para lograr interactividad dinámica.",
        "title": "Panel lateral: Personaliza elementos"
    },
    "addElementCategory": {
        "suggestedElement": "Elementos sugeridos",
        "baseElement": "Elementos base",
        "layoutElement": "Elementos de diseño",
        "formElement": "Elementos de formulario"
    },
    "orientations": {
        "label": "Orientación",
        "horizontal": "Horizontal",
        "vertical": "Vertical"
    },
    "menuElement": {
        "missingValue": "Falta el elemento del menú",
        "separator": "Separador",
        "spacer": "Espaciador",
        "missingLinkValue": "Falta el nombre del enlace…",
        "emptyLinkValue": "Nombre de enlace vacío…",
        "missingButtonValue": "Falta el nombre del botón…",
        "emptyButtonValue": "Nombre de botón vacío…"
    },
    "menuElementForm": {
        "menuItemsLabel": "Elementos del menú",
        "addMenuItemLink": "Añadir...",
        "alignment": "Alineación",
        "menuItemDefaultName": "Página",
        "menuItemLabelLabel": "Etiqueta",
        "menuItemTypeSeparator": "Separador",
        "menuItemTypeLabel": "Tipo",
        "menuItemVariantLabel": "Variante",
        "menuItemVariantLink": "Enlace",
        "menuItemVariantButton": "Botón",
        "namePlaceholder": "Página",
        "addSubLink": "Añadir subenlace",
        "menuItemSubLinkDefaultName": "Subenlace",
        "menuItemAddLink": "Enlace",
        "menuItemAddButton": "Botón",
        "menuItemAddSeparator": "Separador",
        "menuItemAddSpacer": "Espaciador",
        "eventDescription": "Para configurar acciones para este botón, abre la pestaña «Eventos» de este elemento.",
        "noMenuItemsMessage": "Haz clic en «Añadir» para añadir tu primer elemento de menú.",
        "previewCompactMenuHelper": "Mostrar/ocultar la previsualización del menú compacto.",
        "variant": "Variante por tipo de dispositivo",
        "previewCompactMenuLabel": "Previsualizar menú compacto",
        "openEditorCompactMenu": "Abrir menú",
        "closeEditorCompactMenu": "Cerrar menú",
        "expanded": "Expandido",
        "compact": "Compacto"
    },
    "simpleContainerElementForm": {
        "noConfigurationOptions": "El elemento contenedor no tiene ninguna opción de configuración."
    },
    "queryParamTypes": {
        "textName": "Texto",
        "numericName": "Numérico"
    },
    "radiusStyleForm": {
        "cornerRadiusLabel": "Radio de esquina",
        "backgroundRadiusLabel": "Fondo",
        "borderRadiusLabel": "Borde"
    },
    "fontWeightType": {
        "thin": "Delgado",
        "extraLight": "Extra‑ligero",
        "light": "Ligero",
        "medium": "Mediano",
        "semiBold": "Semi‑negrita",
        "bold": "Negrita",
        "extraBold": "Extra‑negrita",
        "black": "Negro",
        "extraBlack": "Extra‑negro",
        "regular": "Regular"
    },
    "userSourceDropdown": {
        "label": "Fuente del usuario",
        "addUserSource": "Agregar nueva fuente de usuario",
        "noUserSources": "No hay fuentes de usuario disponibles"
    },
    "authProviderWithModal": {
        "authProviderInError": "Por favor, edita este proveedor para corregir el error.",
        "title": "Editar proveedor: {name}"
    },
    "textDecorationSelector": {
        "underline": "Subrayar",
        "stroke": "Trazo",
        "italic": "Cursiva",
        "uppercase": "Mayúsculas"
    },
    "ratingFieldForm": {
        "color": "Color",
        "style": "Estilo",
        "maxValue": "Valor máximo",
        "star": "Estrella",
        "heart": "Corazón",
        "thumbsUp": "Pulgar arriba",
        "flag": "Bandera",
        "value": "Valor"
    },
    "ratingElementForm": {
        "color": "Color",
        "ratingStyle": "Estilo",
        "maxValue": "Máximo",
        "star": "Estrella",
        "heart": "Corazón",
        "smile": "Sonrisa",
        "thumbsUp": "Pulgar arriba",
        "flag": "Bandera"
    },
    "automationSettingsModal": {
        "title": "Flujo de trabajo"
    },
    "abFileInput": {
        "delete": "Eliminar"
    },
    "elementsGuidedTourStep": {
        "title": "Añade elementos a tu página",
        "content": "¡Cada aplicación necesita componentes! Añade elementos como tablas, formularios, botones y más para dar vida a tu aplicación."
    },
    "dataGuidedTourStep": {
        "title": "Conecta tus datos",
        "content": "Enlaza tus tablas de Grouper aquí para mostrar, filtrar y actualizar tus datos de forma dinámica en distintos elementos."
    },
    "previewGuidedTourStep": {
        "title": "Tu centro de control",
        "content": "Aquí es donde configuras las páginas de tu aplicación. Añade elementos, previsualiza el resultado y estructura tu aplicación exactamente como deseas."
    },
    "devicesGuidedTourStep": {
        "title": "Previsualizar en diferentes dispositivos",
        "content": "Cambia entre la previsualización de escritorio, tablet y móvil para ver cómo se ve tu aplicación en diferentes tamaños de pantalla. ¡Asegúrate de que tu diseño funcione perfectamente en todos los dispositivos!"
    },
    "previewPublishGuidedTourStep": {
        "title": "Previsualiza y publica tu aplicación",
        "content": "Haz clic en **«Previsualizar»** para probar tu aplicación de forma privada. Cuando estés listo, haz clic en **«Publicar»** para compartirla con el público a través de un dominio."
    },
    "workflowAction": {
        "testActionDescription": "Ejecuta esta acción en modo previsualización para capturar su salida y hacerla disponible a las acciones siguientes.",
        "sampleDataModalTitle": "Carga útil para {actionLabel}",
        "sampleDataModalSubTitle": "Carga útil JSON"
    }
}
